<template>
  <div id="app">
    <Header></Header>
    <div id="router-wrapper">
      <router-view/>
    </div>
  </div>
</template>

<script>

import Header from './components/Header';

export default {
  name: 'App',
  components: { Header },
}
</script>

<style lang="scss">

@import './color.scss';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: white;
  /* margin-top: 60px; */
  /* margin: 0 10px; */
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: white;
}

body {
  margin: 0;
//  height: 100vh;
  //background-color: black
  background-color: $tertiary;
}

h1 {
  cursor: pointer;
}

.toolbar {
  margin-bottom: 1em;
  padding-bottom: 0.2em;
  border-bottom: 1px solid $primary-dark;

  .back-button {
    float: left;
  }
  h2 {
    display: inline-block;
    margin: 0;
  }
}

.btn {
  padding: 0.3em 0.8em;
  //border-radius: 0.5em;
  //background: linear-gradient($secondary-light, $secondary);
  background: $secondary;
  color: $secondary-text;
  display: block;
  margin: 0 auto;
  font-size: 110%;
  font-weight: bold;
  cursor: pointer;
}

.btn-primary {
  //background: linear-gradient($primary-light, $primary);
  background: $secondary;
  color: $secondary-text;
}

.btn-flat {
  //background: white;
  //color: $primary-text;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}

.error {
  color: red;
}

.vdp-datepicker {
    margin: 0 auto 0.3em auto;
    width: 100%;
    min-width: 230px;
    max-width: 435px;

  .vdp-datepicker__calendar {
    width: 100%;
    border: none;

    .cell.selected {
      background: $secondary !important;
      color: $secondary-text;
    }
    .cell.today {
      background: $secondary-light;
      color: $secondary-text;
    }
    .cell:not(.day-header):not(.blank):hover {
      border-color: $secondary-dark !important;
    }
  }
}

// @media screen and (min-width: 600px){
//   #router-wrapper {
//     max-width: 600px;
//     margin: 0 auto;
//   }
// }

</style>



// WEBPACK FOOTER //
// src/App.vue